<ion-item lines="none" color="transparent">
  <ion-label position="floating" mode="md">{{ label }}</ion-label>
  <span class="asterisk">*</span>
  <ion-input
    mode="md"
    [ngClass]="
      hasError || hasValidationError
        ? 'error-input'
        : isWriting
        ? 'writing-input'
        : 'simple-input'
    "
    [type]="typeInputForm"
    [maxlength]="maxLenghtInput"
    debounce="200"
    (ionBlur)="validateInput()"
    (keyup.enter)="validateInput()"
    [(ngModel)]="textToValidate"
    (ionChange)="isWritingOnInput()"
  >
  </ion-input>
  <button
    *ngIf="this.typeInput === 1"
    class="button-icon-eye"
    (click)="changeIconPassword()"
  >
    <ion-icon [name]="iconEye" class="eye-icon" mode="md"></ion-icon>
  </button>
</ion-item>
<p class="error-message" *ngIf="invalidInput">{{ errorMessage }}</p>
<p
  class="error-message"
  *ngIf="wrongPassword && hasValidationError && !invalidInput"
>
  {{ configuracion.mensajesError.error_contrasena_incorrecta }}
</p>
<p
  class="error-message"
  *ngIf="existPhone && hasValidationError && !invalidInput"
>
  {{ configuracion.mensajesError.error_telefono_existente }}
</p>
<p
  class="error-message"
  *ngIf="invalidSMSCode && hasValidationError && !invalidInput"
>
  {{ configuracion.mensajesError.error_sms_incorrecto }}
</p>
